<p>
  Le membre qui exerce ses activités professionnelles au sein d’une société doit fournir et maintenir,
  pour cette société, par la souscription au Fonds d’assurance responsabilité professionnelle de l’Ordre des dentistes du Québec, 
  une garantie contre la responsabilité que cette société peut encourir en raison des fautes ou négligences commises par les membres
  dans l’exercice de leurs activités professionnelles au sein de cette société. 
</p>
<p>
  La protection minimale obligatoire de base de {{ model?.premiumBaseAmount | currencyCustom: 0}} par sinistre et 4 000 000$ par période permet de remplir 
  cette obligation pour <strong>une première société</strong>.
</p>
<p>
  Pour toute société additionnelle, vous devez détenir une protection supplémentaire de {{ model?.period?.minSurplusAmountPerSociety | currencyCustom: 0 }} 
  par sinistre par société, tel qu’exigé par l’article 10 du Règlement sur l’exercice de la profession de dentiste en société.
</p>
<p>
  <a href="https://www.legisquebec.gouv.qc.ca/fr/document/rc/D-3,%20r.%209%20/">
    D-3, r. 9 - Règlement sur l’exercice de la profession de dentiste en société
  </a>
</p>
<span>
  Considérant votre situation, vous devez minimalement souscrire à une protection de {{ model?.premiumMinimum?.premiumAmount | currencyCustom:0 }} 
  par sinistre et 6 000 000$ par période.
  <br><br>
  La limite par sinistre constitue le montant maximal que le Fonds versera dans le cadre d’une réclamation ou d’une série de réclamations découlant des mêmes 
  faits et circonstances, sans égard au nombre de réclamants.
  <br><br>
  La limite par période d’assurance constitue le montant maximal susceptible d’être versé pour l’ensemble des sinistres survenus au cours de la même période.
</span>
<br><br>